import { ThemeOptions } from "@mui/material";
import { cyan, green } from "@mui/material/colors";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "dark",
    primary: green,
    secondary: cyan,
  },
};
